// extracted by mini-css-extract-plugin
export default {"map_box":"mapBox_map_box__F0XSK"};